import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PagedEntitiesGrid from '../../common/components/PagedEntitiesGrid';
import Card from '../../common/components/Card';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import { PaymentTypes } from './actions';


const Grid = ({ t, ...rest }) => {
	const renderItem = item => {
		const center = item.center;
		const paymentKind = (paymentKind) => {
			switch (paymentKind) {
				case PaymentTypes.Lesson: return t('FO_Payment_Type_Lesson');
				case PaymentTypes.Workshop: return t('FO_Payment_Type_Wokshop');
				case PaymentTypes.IndividualConsultation: return t('FO_Payment_Type_Consultation');
			};
		}
		const paymentColor = (paymentKind) => {
			switch (paymentKind) {
				case PaymentTypes.Lesson: return 'purple';
				case PaymentTypes.Workshop: return 'orange';
				case PaymentTypes.IndividualConsultation: return 'green';
			};
		}
		return <Card key={item.id} color={paymentColor(item.paymentKind)} className={item.status === 'Pending' || item.status === 'NotApproved' ? 'bg-danger' : ''} style={{ marginBottom: 15 }}>
			<div>
				<span className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }}>
					<FontAwesome name='credit-card' className={`text-${paymentColor(item.paymentKind)}`} />
				</span>
				<div>
					<h4>{center && center.name}</h4>
					<h4 className='text-muted'>{`#${item.id}`} {paymentKind(item.paymentKind)}</h4>
				</div>
			</div>
			<div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }}>{item.child && item.child.shortName}</div>
			<div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }}>{t(`PaymentStatusType_${item.status}`)} <span className='pull-right'>{item.total}</span></div>
			<div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }}>{t('FO_Payment_PaidTotalAmount')} <span className='pull-right'>{item.paidTotal}</span></div>
			<div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }}>{t('FO_Payment_OutstandingTotalAmount')} <span className='pull-right'>{item.outstandingTotal}</span></div>
			<div style={{ position: 'relative' }}>
				<div className='text-muted'>
					<div>{t('FO_Payment_Created')}</div>
					<div>{moment(item.created).format('lll')}</div>
				</div>
				<div style={{ position: 'absolute', bottom: 0, right: 0 }}><Link to={`/payment-history/${item.id}/${item.paymentKind}`}>{t('FO_Payment_Details')}</Link></div>
			</div>
		</Card>;
	}

	return <PagedEntitiesGrid itemsPerRow={1} itemComponent={renderItem} {...rest} />;
};

Grid.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		child: PropTypes.shape({
			shortName: PropTypes.string
		}),
		center: PropTypes.shape({
			name: PropTypes.string
		}),
		created: PropTypes.string
	}))
};

export default withNamespaces()(Grid);